var _g, _g2, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#chat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 8c11.028 0 20 8.973 20 20v18.75c0 .69-.56 1.25-1.25 1.25H36c-11.027 0-20-8.972-20-20 0-11.027 8.973-20 20-20Z",
    fill: "#76CDD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 28c0-10.475-8.525-19-19-19s-19 8.525-19 19 8.525 19 19 19h18.75a.25.25 0 0 0 .25-.25V28Z",
    stroke: "#40B6C2",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chat_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.373 23.966h1.657c1.41-3.346 4.512-5.778 8.085-6.242 3.54-.472 7.019.89 9.294 3.634.67.806 1.2 1.683 1.589 2.608h1.629A2.376 2.376 0 0 1 50 26.34v3.164a2.376 2.376 0 0 1-2.373 2.373h-3.248l.34-1.037c.989-3.022.432-6.11-1.528-8.471a8.695 8.695 0 0 0-7.87-3.076c-3.178.414-5.935 2.66-7.028 5.726l-.007.017c-.176.468-.3.95-.37 1.445a8.706 8.706 0 0 0 .39 4.336l.003.01a8.684 8.684 0 0 0 8.175 5.797 2.383 2.383 0 0 1 2.389 2.373 2.376 2.376 0 0 1-2.373 2.373 2.376 2.376 0 0 1-2.373-2.373v-1.067a10.27 10.27 0 0 1-7.087-6.053h-1.667A2.376 2.376 0 0 1 23 29.503V26.34a2.376 2.376 0 0 1 2.373-2.373Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.62 33.459v1.581H36.5a7.127 7.127 0 0 1-7.12-7.119 7.127 7.127 0 0 1 7.12-7.119 7.127 7.127 0 0 1 7.12 7.12c0 1.6-.538 3.146-1.521 4.397.19.667.8 1.14 1.52 1.14Zm-9.493-6.329h-1.582v1.582h1.582V27.13Zm3.164 0h-1.582v1.582h1.582V27.13Zm3.164 0h-1.582v1.582h1.582V27.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31 26h11v4H31z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 28,
    r: 1,
    fill: "#069BAA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 28,
    r: 1,
    fill: "#069BAA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 28,
    r: 1,
    fill: "#069BAA"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 12,
    r: 2.75,
    fill: "#43CD39",
    stroke: "#9FF087",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chat_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 50 16)",
    d: "M0 0h27v27H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "chat_svg__a",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22892_13708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_22892_13708",
    result: "shape"
  })))));
};
export default SvgChat;